"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createId = void 0;
var nanoid_1 = require("nanoid");
var switchUtil_1 = require("./switchUtil");
var createId = function (length) {
    if (length === void 0) { length = 'long'; }
    return nanoid_1.nanoid(switchUtil_1.switchUtil(length, {
        'long': 21,
        'short': 8
    }));
};
exports.createId = createId;
